<ng-container *transloco="let t">
  <ng-container *ngIf="vm$ | async as vm">
    <ng-container *ngIf="isActive">
      <header>
        <div class="header-container">
          <img src="/assets/logo/logo-white.png" width="350" class="logo plm"/>
          <span class="version">V{{version}}</span>
        </div>
        
        <a class="logout-link" (click)="onLogout()">{{ t('nav.logout') }}</a>
      </header>
      <div class="custom-toolbar">
        <button
          kendoButton
          fillMode="flat"
          size="large"
          rounded="large"
          themeColor="primary"
          icon="menu"
          (click)="drawer.toggle()"
        ></button>
      </div>
      <kendo-drawer-container>
        <kendo-drawer
          #drawer
          [items]="items"
          mode="push"
          [mini]="false"
          [expanded]="isExpanded"
          [animation]="false"
          [autoCollapse]="collapseMenuAfterClick"
        >
          <ng-template kendoDrawerHeaderTemplate> </ng-template>

          <ng-template kendoDrawerItemTemplate let-item>
            <div
              class="k-drawer-link k-level-{{ item.level }} nav-item-link"
              [routerLink]="item.path"
            >
              <span>{{ item.text }}</span>
              <ng-container *ngIf="item.path === 'expenses'">
                <span *ngIf="(expenseReviewCount$ | async) as reviewCount" class="count-circle">
                  {{ reviewCount }}
                </span>
              </ng-container>
            </div>
          </ng-template>

          <ng-template kendoDrawerFooterTemplate>
            <div class="drawer-footer">
              <a
                [href]="documentationLinks.base"
                target="_blank"
                class="info-button">
                <img src="../assets/icons/information-icon.svg">{{ t('nav.guides') }}
              </a>
              <a
                href="https://quick-planner.com/datenschutz"
                target="_blank">
                {{ t('nav.privacy') }}
              </a>
              <div class="credentialsContainer">
                <span class="credentialsText prs">powered by </span>
                <a
                  href="https://www.gizmo.swiss?utm_source=quickplanner&utm_medium=logo&utm_campaign=none"
                  target="_blank">
                    <img class="gizmoLogo" src="../assets/logo/logo_gizmo_blau.svg"/>
                </a>
              </div>
            </div>

          </ng-template>
        </kendo-drawer>

        <kendo-drawer-content>
          <main class="main">
            <router-outlet *ngIf="router.url != '/auth'"></router-outlet>
          </main>
        </kendo-drawer-content>
      </kendo-drawer-container>
    </ng-container>

    <router-outlet *ngIf="router.url === '/auth'"></router-outlet>

    <app-notification></app-notification>
  </ng-container>
</ng-container>
